import React from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.css";
import "./App.css";
import App from "./App";
import AuthProvider from "./services/AuthService";
// import { rootThemeCss } from "@ttd/theme/lib/index";
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <AuthProvider>
//       <App />
//     </AuthProvider>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import { createRoot } from "react-dom/client";

// import { lingoStrings } from "./lingoStrings";
// import {
//   LingoGlobalStyles,
//   LingoProvider,
// } from "@ttd/lingo/lib/components/LingoProvider";

import { OidcConfig } from "./services/ConstantService";

function onSigninCallback() {
  window.location.href = "/";
}

const rootNode = document.querySelector("#root");

createRoot(rootNode).render(
  <AuthProvider {...OidcConfig} onSigninCallback={onSigninCallback}>
    {/* <LingoProvider
      appName="clientFileUpload"
      isDev={process.env.NODE_ENV === "development"}
      localizationSettings={lingoStrings}
      rootNode={rootNode}
      styles={[...LingoGlobalStyles, ...rootThemeCss]}
    >
      <App />
    </LingoProvider> */}
    <App />
  </AuthProvider>
);
